import React from 'react';
import { CustomLabelTemplate } from 'themes/modules/channel/pages';
import { CustomLabelViewStore } from 'modules/channel/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(
	(rootStore, componentProps) => new CustomLabelViewStore(rootStore, componentProps),
	'customLabelViewStore'
)
class CustomLabel extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <CustomLabelTemplate {...this.props} viewStore={this.props.customLabelViewStore} />;
	}
}

export default CustomLabel;
